// extracted by mini-css-extract-plugin
module.exports = {"item":"work-item-module--item--3svmO","active":"work-item-module--active--1nRAL","title":"work-item-module--title--1Aogx","image":"work-item-module--image--3M69A"};